import { render, staticRenderFns } from "./objectTypeAdd.vue?vue&type=template&id=c4fad440"
import script from "./objectTypeAdd.vue?vue&type=script&lang=js"
export * from "./objectTypeAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4fad440')) {
      api.createRecord('c4fad440', component.options)
    } else {
      api.reload('c4fad440', component.options)
    }
    module.hot.accept("./objectTypeAdd.vue?vue&type=template&id=c4fad440", function () {
      api.rerender('c4fad440', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/objectType/objectTypeAdd.vue"
export default component.exports